import backofficeService from '../../api/backoffice'
import bonventaService from '../../api/bonventa'

export default {
  getAll(params) {
    return backofficeService.Api().get('crm/api/groupMessages', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getById(id, params) {
    return bonventaService.Api().get(`terminal/location/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  update(id, data) {
    return bonventaService.Api().put(`terminal/location/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}
